module.exports = __webpack_public_path__ + "static/media/token-btcb.dbf17dbd.svg";